import { Table, SquaresFour } from '@phosphor-icons/react';
import './ViewToggle.css';

function ViewToggle({ view, onViewChange, disableTable = false }) {
  const handleTableClick = () => {
    if (!disableTable) {
      onViewChange('table');
    }
  };

  return (
    <div className="view-toggle">
      <button
        className={`view-toggle-btn ${view === 'table' ? 'active' : ''} ${disableTable ? 'disabled' : ''}`}
        onClick={handleTableClick}
        title={disableTable ? "תצוגת טבלה לא זמינה במובייל" : "תצוגת טבלה"}
        disabled={disableTable}
      >
        <Table size={18} weight={view === 'table' ? 'fill' : 'regular'} />
      </button>
      <button
        className={`view-toggle-btn ${view === 'cards' ? 'active' : ''}`}
        onClick={() => onViewChange('cards')}
        title="תצוגת כרטיסים"
      >
        <SquaresFour size={18} weight={view === 'cards' ? 'fill' : 'regular'} />
      </button>
    </div>
  );
}

export default ViewToggle;

